import { use } from 'react'

import { ThemeContext } from '#providers/ThemeProvider'
import type { IThemeContext } from '#providers/ThemeProvider/interfaces'

export function useTheme(): IThemeContext {
  const context = use(ThemeContext)
  if (!context) throw new Error('useTheme must be used within a ThemeProvider')

  return context
}
